var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c("content-header", [
        _c(
          "div",
          {
            staticClass: "header-left-box",
            attrs: { slot: "header-left" },
            slot: "header-left",
          },
          [
            _c(
              "div",
              { staticClass: "return-prev", on: { click: _vm.retuenPrev } },
              [
                _c("span", { staticClass: "icon-box" }, [
                  _c("span", { staticClass: "el-icon-arrow-left" }),
                ]),
                _c("span", { staticClass: "return-text" }, [
                  _vm._v(_vm._s(_vm.$t("planLxDetail.FH"))),
                ]),
              ]
            ),
            _c("content-header-title", [
              _c("span", [_vm._v(_vm._s(_vm.planData.planDto.planName))]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "header-right",
            attrs: { slot: "header-right" },
            slot: "header-right",
          },
          [
            _vm.isBtn.btnCreateTeam
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        _vm.$refs["studentDialog"].dialogData.addLxDialog = true
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.CJTD")))]
                )
              : _vm._e(),
            _vm.isBtn.btnUpdateRace
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.modifyMatch },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.XGLX")))]
                )
              : _vm._e(),
            _vm.isBtn.btnResetRace
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: [["teacher", "student"], "pro"],
                        expression: "[['teacher', 'student'], 'pro']",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        _vm.openMatch(_vm.planData.planDto.status > 0)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.__userData.prodIsFree == 0 &&
                          _vm.planData.planDto.rule == 0
                          ? _vm.$t("planLxDetail.QBJJAN")
                          : _vm.$t("planLxDetail.CZLX")
                      ) + " "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isBtn.btnOpenRace
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: _vm.isKtPlan != _vm.$t("planLxDetail.KTLX"),
                    },
                    on: {
                      click: () => {
                        _vm.openMatch(_vm.planData.planDto.status > 0)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.isKtPlan))]
                )
              : _vm._e(),
            _vm.isBtn.btnSeekScore
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: [["teacher", "student"], "pro"],
                        expression: "[['teacher', 'student'], 'pro']",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        _vm.goShowFraction(_vm.planData.planDto.planId)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.CKCJ")))]
                )
              : _vm._e(),
            _vm.isBtn.btnSeekScore
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: [["teacher", "student"], "pro"],
                        expression: "[['teacher', 'student'], 'pro']",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        _vm.exportScoreBtn(
                          _vm.planData.planDto.planId,
                          _vm.planData.planDto.planName
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.DCCJ")))]
                )
              : _vm._e(),
            _vm.isFiscal &&
            !!_vm.planData.planDto.isMarking &&
            !_vm.planData.planDto.status
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        _vm.openMarkPaperBtn(_vm.planData.planDto.planId)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.LXJHKFYJ")))]
                )
              : _vm._e(),
            _vm.isFiscal &&
            !!_vm.planData.planDto.isMarking &&
            !_vm.planData.planDto.status
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        _vm.pullMainScore(_vm.planData.planDto.planId)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.LQZGTCJ")))]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.planData.planDto.status == 1,
                    expression: "planData.planDto.status == 1",
                  },
                ],
                attrs: { type: "primary", size: "small" },
                on: {
                  click: () => {
                    _vm.scheduleDialogVisible = true
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("planLxDetail.CSHCX")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("top-sub", {
            attrs: {
              planDto: _vm.planData.planDto,
              lastingStatisDto: _vm.planData.lastingStatisDto,
              pendingStatisDto: _vm.planData.pendingStatisDto,
            },
          }),
          _c("team-list", {
            attrs: {
              listArr: _vm.planData.teamList,
              pageBtnStatusDto: _vm.planData.pageBtnStatusDto,
              planDto: _vm.planData.planDto,
            },
          }),
        ],
        1
      ),
      _c("student-dialog", {
        ref: "studentDialog",
        on: {
          next: function ($event) {
            _vm.$refs["leaderDialog"].dialogDataLeader.addLxDialog = true
          },
        },
      }),
      _c("dialog-plan", { ref: "dialogPlan" }),
      _c("leader-dialog", {
        ref: "leaderDialog",
        on: {
          successClick: _vm.successClick,
          prev: function ($event) {
            _vm.$refs["leaderDialog"].dialogDataLeader.addLxDialog = false
            _vm.$refs["studentDialog"].dialogData.addLxDialog = true
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.scheduleDialogVisible,
            width: "556px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.scheduleDialogVisible = $event
            },
          },
        },
        [
          _vm.resetData.failCount <= 0
            ? _c("div", { staticClass: "alldDialog" }, [
                _vm.resetData.unFinished > 0 && _vm.resetData.isStartInited == 1
                  ? _c("div", { staticClass: "undone" }, [
                      _c("div", { staticClass: "mains" }, [
                        _c("span", { staticClass: "img" }),
                        _c("div", { staticClass: "allText" }, [
                          _c("div", { staticClass: "detial" }, [
                            _vm._v(_vm._s(_vm.$t("planLxDetail.SJCSHJXZ"))),
                          ]),
                          _c("div", { staticClass: "team" }, [
                            _vm._v(_vm._s(_vm.$t("planLxDetail.DQPDXZS"))),
                            _c("span", { staticStyle: { color: "#000000" } }, [
                              _vm._v(_vm._s(_vm.resetData.waitCount || "1")),
                            ]),
                            _vm._v(_vm._s(_vm.$t("planLxDetail.GYJRX"))),
                            _c("span", { staticStyle: { color: "#09C579" } }, [
                              _vm._v(_vm._s(_vm.newwaitCount)),
                            ]),
                            _vm._v(_vm._s(_vm.$t("planLxDetail.FZ"))),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "body" }, [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              color: "#0F0D11",
                              "font-weight": "700",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("planLxDetail.YQTS")) + " ")]
                        ),
                        _c("p", [_vm._v(_vm._s(_vm.$t("planLxDetail.XCJY")))]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.resetData.unFinished > 0 && _vm.resetData.isStartInited == 0
                  ? _c("div", { staticClass: "done" }, [
                      _c("h2", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(_vm._s(_vm.$t("planLxDetail.QKTJH"))),
                      ]),
                    ])
                  : _vm.resetData.unFinished == 0
                  ? _c("div", { staticClass: "done" }, [
                      _c("div", { staticClass: "doneHeader" }, [
                        _c("span", { staticClass: "img" }),
                        _c("h1", [_vm._v(_vm._s(_vm.$t("planLxDetail.GXN")))]),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm.resetData.isStartInited == undefined
            ? _c("div", { staticClass: "elseDialog" }, [
                _c("div", { staticClass: "done" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.SJJDJZZ")) + "......"),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "elseDialog" }, [
                _c("div", { staticClass: "done" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.DBQXTKNCZSJYCL"))),
                  ]),
                ]),
              ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.resetData.waitCount
                ? _c(
                    "el-button",
                    {
                      staticStyle: {
                        background:
                          "linear-gradient(135deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%)",
                        "border-radius": "4px",
                      },
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.scheduleDialogVisible = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("planLxDetail.ZDL")) + " ")]
                  )
                : _c(
                    "el-button",
                    {
                      staticStyle: {
                        background:
                          "linear-gradient(135deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%)",
                        "border-radius": "4px",
                      },
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.scheduleDialogVisible = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("planLxDetail.HD")) + " ")]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }